<template>
  <div>
    <div class="unAuth auth" :class="{ iconType }" v-if="authType === 'unAuth'" @click="toAccountAuth">
      <img src="@/assets/image/home/header/icon_7.webp" alt="" srcset="" />
      <div>未实名</div>
      <p class="el-icon-arrow-right"></p>
    </div>
    <div
      class="unCompanyAuth auth"
      :class="{ iconType }"
      v-if="authType === 'unCompanyAuth'"
      @click="showMode1"
    >
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="none"
        version="1.1"
        width="8"
        height="8"
        viewBox="0 0 8 8"
      >
        <g>
          <path
            d="M0,0Q3.6,0.4,5.6,2.4Q7.6,4.4,8,8L8,0L0,0Z"
            fill="#FFE7E7"
            fill-opacity="1"
          />
        </g>
      </svg>
      <img src="@/assets/image/home/header/icon_3.webp" alt="" srcset="" />
      <div>未认证</div>
      <p class="el-icon-arrow-right"></p>
    </div>
    <div class="allAuth auth" :class="{ iconType }" v-if="authType === 'allAuth'">
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="none"
        version="1.1"
        width="8"
        height="8"
        viewBox="0 0 8 8"
      >
        <g>
          <path
            d="M0,0Q3.6,0.4,5.6,2.4Q7.6,4.4,8,8L8,0L0,0Z"
            fill="#e5f9ee"
            fill-opacity="1"
          />
        </g>
      </svg>
      <img src="@/assets/image/home/header/icon_4.webp" alt="" srcset="" />
      <div>已认证</div>
    </div>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo";

// type   unAuth 个人未认证， unCompanyAuth 企业未认证   allAuth  全部认证
export default {
  mixins: [userinfo],
  props: {
    iconType: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.auth {
  // width: 60px;
  padding: 0 6px;
  height: 20px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  font-family: "Noto Sans SC";
  font-size: 12px;
  color: #666666;

  z-index: 1;
  p {
    font-size: 8px;
  }
  .icon {
    display: none;
  }
  img {
    width: 8px;
    height: 10px;
  }
}
.unAuth {
  cursor: pointer;
}
.unCompanyAuth {
  background: #ffe7e7;
  color: #ff0d0d;
  cursor: pointer;
}
.allAuth {
  background: #e5f9ee;
}
.iconType {
  border-radius: 0 0 0 8px;
  position: relative;
  .icon {
    position: absolute;
    left: -8px;
    top: 0;
    display: block;
  }
}
</style>
